import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map, take } from 'rxjs/operators';
import { CustomerResource } from '../../resources/customer.resource';

@Injectable()
export class SearchNameExistsGuard implements CanActivate {
  constructor(
    private customerResource: CustomerResource,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const searchName: string = route.queryParams['search_name'];
    return this.customerResource.getPublicCustomer(searchName).pipe(
      take(1),
      map(publicCustomer => {
        if (publicCustomer && publicCustomer.name) {
          this.router.navigate(['/client/' + publicCustomer.name]);
          return true;
        } else {
          this.router.navigate(['/customer-not-found']);
          return false;
        }
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/search-name-exists.guard.ts